<template>
  <div>
    <button-global type="negative" text="DELETE" size="small" @eventPassed="deleteButtonClicked"/>
  </div>
</template>

<script>
import { db } from '@/firebase'
import ButtonGlobal from '@/components/GlobalComponents/ButtonGlobal'

export default {
  name: "DeleteEvent",
  props: {
    eventId: {
      required: true, 
      type: String
    },
    eventName: {
      required: true, 
      type: String
    }
  },
  components: {
    ButtonGlobal
  },
  methods: {
    deleteButtonClicked() {
      this.$swal({
        title: `Delete ${this.eventName} ?`,
        text: "Are you sure?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          await this.deleteEvent();
        }
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.$swal("Event Deleted", `You succesfully deleted ${this.eventName}`, "success")
            .then(() => {
              this.$emit('event-deleted', this.eventId)
            })
        }
      })
    },
    deleteEvent() {
      const referenceArray = [
        `activeguests/${this.$customerId}`,
        `customers/${this.$customerId}/events`,
        `files/${this.$customerId}`,
        `hotels/${this.$customerId}`,
        `hotelsList/${this.$customerId}`,
        `images/${this.$customerId}`,
        `messages/${this.$customerId}`,
        `pages/${this.$customerId}`,
        `quarantine/${this.$customerId}`,
        `rooms/${this.$customerId}`,
      ];

      // Removing rest of customer's event entries according to list
      const promises = [];

      referenceArray.forEach(item => {
        promises.push( db.ref(`${item}/${this.backwardCompatibleEventId}`).remove() );
      });

      // Backwards compatible until no _eventX events exist
      if (!this.eventId.includes(this.$customerId)) {
        promises.push( db.ref(`customers/${this.$customerId}/events/${this.eventId}`).remove() );
      }

      return Promise.all(promises);
    },
  },
  computed: {
    backwardCompatibleEventId() {
      if (this.eventId.includes(this.$customerId)) {
        return this.eventId;
      } else {
        return this.$customerId + '_' + this.eventId;
      }
    }
  }
}
</script>
